import {
  IonSelect,
  IonSelectOption
} from "@ionic/react";
import type { ReactNode } from "react";
import { SpaShell } from "../../../platform";
import { currencyOptions } from "../constants";
import type { CurrencyPreference, CurrencyOption, SpendTrackAppSettings, ThemeMode } from "../types";

interface SpendTrackShellProps {
  children: ReactNode;
  currencyPreference: CurrencyPreference;
  selectedCurrencyOption: CurrencyOption;
  settings: SpendTrackAppSettings;
  themeMode: ThemeMode;
  onCurrencyPreferenceChange: (preference: CurrencyPreference) => void;
}

export function SpendTrackShell({
  children,
  currencyPreference,
  selectedCurrencyOption,
  settings,
  themeMode,
  onCurrencyPreferenceChange
}: SpendTrackShellProps) {
  return (
    <SpaShell
      contentClassName="tracker-content"
      navigation={settings}
      themeClassName={`theme-${themeMode}`}
      endControls={
        <>
          <IonSelect
            aria-label="Currency"
            interface="popover"
            value={`${currencyPreference.locale}|${currencyPreference.currency}`}
            selectedText={selectedCurrencyOption.flag}
            onIonChange={(event) => {
              const [locale, currency] = String(event.detail.value).split("|");
              onCurrencyPreferenceChange({ locale, currency });
            }}
          >
            {currencyOptions.map((option) => (
              <IonSelectOption value={`${option.locale}|${option.currency}`} key={`${option.locale}-${option.currency}`}>
                {option.flag} {option.label}
              </IonSelectOption>
            ))}
          </IonSelect>
          <span className="currency-selected-text" aria-hidden="true">
            {selectedCurrencyOption.shortLabel}
          </span>
        </>
      }
    >
      {children}
    </SpaShell>
  );
}
